//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { htmlEncode } from '@utils/htmlEncode';
import { MediaTrackingEventName } from '@tracker/mediaTracking/mediaTrackingModel';
import universalImageActionsNotesTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-notes.html';

(function () {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsNotes', [
    '$timeout',
    '$window',
    function ($timeout, $window) {
      return {
        restrict: 'E',
        scope: {
          features: '=',
        },
        template: universalImageActionsNotesTemplate,
        controller: [
          '$q',
          '$scope',
          'ErrorNotificationService',
          'NotesService',
          'ScrollAnimationService',
          'SessionVarsService',
          'ShareWarningNote',
          'TrackingService',
          'UniversalImageActionsHelpers',
          'UniversalImageActionsItemType',
          'UniversalImageActionsService',
          function (
            $q,
            $scope,
            ErrorNotificationService,
            NotesService,
            ScrollAnimationService,
            SessionVarsService,
            ShareWarningNote,
            TrackingService,
            UniversalImageActionsHelpers,
            UniversalImageActionsItemType,
            UniversalImageActionsService,
          ) {
            const launchOptions =
              UniversalImageActionsService.getCurrentLaunchOptions();
            const currentPage = UniversalImageActionsService.getCurrentPage();
            const currentUserId = SessionVarsService.getUserId().toString();
            const uid = launchOptions.getUniversalItemId();
            const MAX_BACKOFF = 6; // maximum refresh duration of 2^6 * 2 = 128 seconds
            const TRACKING_CATEGORY =
              UniversalImageActionsHelpers.getTrackingCategory(currentPage);
            const START_FADING_HEIGHT = 25;
            const SCROLL_EVENTS = 'scroll wheel mousewheel';
            let outstandingRefresh = false;
            const TOO_MANY_USERS = 9; // The point where there are too many users in the subscribers dropdown to fit on one screen
            let maxHeight;

            $scope.model = {
              backoff: 0,
              loading: true,
              MAX_LENGTH: 2000,
              REFRESH_DURATION_IN_MS: 2 * 1000,
              notes: [],
              noteText: '',
              outstandingAsyncAction: null,
              partnerNames: [],
              SHARE_WARNING_NOTE: ShareWarningNote,
              isShareItem:
                launchOptions.itemType ===
                UniversalImageActionsItemType.syndication,
              submitted: false,
            };

            $scope.model.tooManyUsers = function () {
              return (
                _($scope.model.taggableUsers).filter((user) => {
                  return user.isSubscribed;
                }).length > TOO_MANY_USERS
              );
            };

            $scope.model.subscribeUser = function (user) {
              if (!user || !user.id) {
                return;
              }

              const userId = user.id;

              NotesService.subscribeUserAsync(uid, userId).then(() => {
                const subscribedUser = _($scope.model.taggableUsers).findWhere({
                  id: userId,
                });

                if (subscribedUser) {
                  subscribedUser.isSubscribed = true;
                }
              });
            };

            $scope.model.calculateHeight = function () {
              return maxHeight - angular.element('.note-input-fields').height();
            };

            $scope.model.mentio = {
              triggerCharacter: '@',
              selectCallback(item) {
                return `<span class="at-mention" user-id="${item.id}" contenteditable="false">${item.label}</span>`;
              },
            };

            $scope.model.unsubscribeUser = function (userId) {
              NotesService.unsubscribeUserAsync(uid, userId).then(() => {
                const user = _($scope.model.taggableUsers).findWhere({
                  id: userId,
                });

                if (user) {
                  user.isSubscribed = false;
                }
              });
            };

            $scope.model.isSubmitButtonDisabled = function () {
              return (
                $scope.model.outstandingAsyncAction ||
                ($scope.model.submitted &&
                  $scope.noteInputForm.noteText.$invalid)
              );
            };

            $scope.model.preventDefault = function ($event) {
              $event.preventDefault();
              $event.stopPropagation();
            };

            $scope.model.shouldExpandNoteInput = function () {
              return (
                ($scope.model.noteText &&
                  !_.isEmpty($scope.model.noteText.trim())) ||
                _($scope).safeGet(
                  'noteInputForm.noteText.$error.contenteditablemaxlength',
                )
              );
            };

            $scope.model.scrollToBottom = function (skipAnimation) {
              $timeout(() => {
                ScrollAnimationService.scroll(
                  angular.element('.modal-body-form')[0],
                  'bottom',
                  skipAnimation,
                );
              }, 0);
            };

            $scope.model.isScrolledToBottom = function () {
              const modalBodyElement = angular.element('.modal-body-form');
              const currentScrollTop = modalBodyElement.prop('scrollTop');
              const maxScrollTop =
                modalBodyElement.prop('scrollHeight') -
                modalBodyElement.height();

              return maxScrollTop - currentScrollTop < START_FADING_HEIGHT;
            };

            $scope.model.isScrolledToTop = function () {
              return (
                angular.element('.modal-body-form').prop('scrollTop') === 0
              );
            };

            $scope.model.addNote = function () {
              if ($scope.model.isSubmitButtonDisabled()) {
                return;
              }

              $scope.model.submitted = true;
              if (!$scope.noteInputForm.$valid) {
                return;
              }

              $scope.model.outstandingAsyncAction = 'add-note';

              const noteInputElement = angular.element('.note-input')[0];
              const sanitizedNoteText =
                noteInputElement.innerText || noteInputElement.textContent;

              const mentionedUsers =
                NotesService.getMentionedUsers(noteInputElement);
              UniversalImageActionsService.trackMediaEvent(
                MediaTrackingEventName.NoteAdded,
              );

              NotesService.addNoteAsync(uid, sanitizedNoteText, mentionedUsers)
                .then((response) => {
                  const usersToUpdate = _(mentionedUsers).map((user) => {
                    return user.id;
                  });

                  $scope.model.noteText = '';
                  $scope.model.submitted = false;
                  $scope.model.notes = response.notes;
                  $scope.model.scrollToBottom();

                  usersToUpdate.push(currentUserId);

                  _(usersToUpdate).each((id) => {
                    const user = _($scope.model.taggableUsers).findWhere({
                      id: parseInt(id, 10),
                    });

                    if (user) {
                      user.isSubscribed = true;
                    }
                  });

                  TrackingService.recordEvent(
                    TRACKING_CATEGORY,
                    TrackingService.ACTION_ADD_NOTE,
                  );
                })
                .catch((error) => {
                  ErrorNotificationService.showDefaultErrorDialog(error);
                })
                .finally(() => {
                  $scope.model.outstandingAsyncAction = null;
                });
            };

            $scope.$watch('model.noteText', (newText, oldText) => {
              if (newText && newText !== oldText) {
                $scope.model.scrollToBottom();
              }
            });

            $scope.$on('uia:notes-changed', ($event, newNotes) => {
              $scope.model.notes = newNotes;
            });

            $scope.model.refreshAndDelayInterval = function () {
              outstandingRefresh = true; // Keep track of async refreshes using this; if this is false, no refreshAndDelayInterval is running
              NotesService.refreshNotesAsync(uid)
                .then(() => {
                  $scope.model.backoff = Math.min(
                    $scope.model.backoff + 1,
                    MAX_BACKOFF,
                  );
                  // Do not keep refreshing if the refreshPromise has been set to null by the cancelRefreshInterval method
                  if ($scope.model.refreshPromise) {
                    $scope.model.refreshPromise = $timeout(
                      $scope.model.refreshAndDelayInterval,
                      $scope.model.REFRESH_DURATION_IN_MS *
                        $scope.model.backoff ** 2,
                    );
                  }
                })
                .finally(() => {
                  outstandingRefresh = false;
                });
            };

            $scope.model.cancelRefreshInterval = function () {
              $timeout.cancel($scope.model.refreshPromise);
              $($window).off('focus', $scope.model.restartRefreshInterval);
              // Cancel the refresh promise if a refreshAndDelayInterval method is still running asynchronously
              $scope.model.refreshPromise = null;
            };

            $scope.model.restartRefreshInterval = function () {
              $scope.model.backoff = 0; // If we are currently refreshing, this is all we need to do to reset the refresh backoff

              if (!outstandingRefresh && $scope.model.refreshPromise) {
                // We are not currently refreshing, so cancel the refresh promise and start a new one
                $timeout.cancel($scope.model.refreshPromise);
                $scope.model.refreshAndDelayInterval();
              }
            };

            $scope.model.computeHeight = function () {
              maxHeight = $(window).height();
            };

            function initialize() {
              $scope.model.computeHeight();
              $window.addEventListener('resize', $scope.model.computeHeight);

              $q.all([
                NotesService.getNotesAsync(uid),
                NotesService.getSubscriptionsAsync(uid),
              ])
                .then((responses) => {
                  $scope.model.notes = responses[0].notes;
                  $scope.model.partnerNames = responses[0].partnerNames;
                  $scope.model.taggableUsers = _(responses[1]).map((user) => {
                    // copy the name attribute as a label attribute for mentio
                    return {
                      ...user,
                      // HTML encode the display label for safety
                      label: htmlEncode(user.name),
                      // Leave this label un-encoded so it's more easily searchable.
                      searchLabel: user.name,
                    };
                  });

                  if ($scope.model.taggableUsers.length > 1) {
                    $scope.model.otherUsersToNotify = true;
                  }

                  $scope.model.scrollToBottom(/* skipAnimation */ true);

                  angular
                    .element('.universal-image-actions-notes')
                    .on(SCROLL_EVENTS, () => {
                      $scope.$apply($scope.model.isScrolledToBottom());
                      $scope.$apply($scope.model.isScrolledToTop());
                    });
                })
                .catch((error) => {
                  ErrorNotificationService.showDefaultErrorDialog(error);
                })
                .finally(() => {
                  $scope.model.loading = false;
                });
            }

            initialize();
          },
        ],
        link(scope, element) {
          element.on('$destroy', () => {
            scope.model.cancelRefreshInterval();
            window.removeEventListener('resize', scope.model.computeHeight);
          });

          $($window).on('focus', scope.model.restartRefreshInterval);
          scope.model.refreshPromise = $timeout(
            scope.model.refreshAndDelayInterval,
            scope.model.REFRESH_DURATION_IN_MS,
          );
        },
      };
    },
  ]);
})();
